/* Bolaméa : recalcule dans le navigateur la fourchette de livraison écrite par le snippet
   bv-estimation-livraison (fiche produit, FAQ, bandeau d'annonce). Même règle que côté boutique :
   jours ouvrés à partir du lendemain, samedi et dimanche exclus, heure de Paris.
   Le fichier peut être chargé plusieurs fois sur une page : il ne s'exécute qu'une fois. */
(() => {
  if (window.bvEstimation) return;

  const jours = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  const mois = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  const nbsp = ' ';

  /* Aujourd'hui à Paris, à midi UTC : pas d'effet du changement d'heure ni du fuseau du visiteur. */
  const aujourdhui = () => {
    const p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    const [a, m, j] = p.split('-').map(Number);
    return new Date(Date.UTC(a, m - 1, j, 12));
  };

  const fourchette = (min, max) => {
    const d = aujourdhui();
    let compte = 0;
    let debut = null;
    while (compte < max) {
      d.setUTCDate(d.getUTCDate() + 1);
      const js = d.getUTCDay();
      if (js === 0 || js === 6) continue;
      compte += 1;
      if (compte === min) debut = new Date(d);
    }
    return [debut, d];
  };

  const libelles = (debut, fin, format) => {
    const finCourt = `${fin.getUTCDate()}${nbsp}${mois[fin.getUTCMonth()]}`;
    if (format === 'court') {
      const memeMois = debut.getUTCMonth() === fin.getUTCMonth();
      return [memeMois ? `${debut.getUTCDate()}` : `${debut.getUTCDate()}${nbsp}${mois[debut.getUTCMonth()]}`, finCourt];
    }
    return [
      `${jours[debut.getUTCDay()]}${nbsp}${debut.getUTCDate()}${nbsp}${mois[debut.getUTCMonth()]}`,
      `${jours[fin.getUTCDay()]}${nbsp}${finCourt}`,
    ];
  };

  const majour = () => {
    document.querySelectorAll('.bv-estimation[data-min][data-max]').forEach((el) => {
      const min = parseInt(el.dataset.min, 10);
      const max = parseInt(el.dataset.max, 10);
      if (!(min > 0) || !(max >= min)) return;
      try {
        const [d, f] = fourchette(min, max);
        const [debut, fin] = libelles(d, f, el.dataset.format);
        const texte = (el.dataset.texte || '').replace('[debut]', debut).replace('[fin]', fin);
        if (texte && el.textContent !== texte) el.textContent = texte;
      } catch (e) {
        /* Navigateur sans Intl ou fuseau inconnu : on garde la date calculée par la boutique. */
      }
    });
  };

  window.bvEstimation = { majour };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', majour, { once: true });
  } else {
    majour();
  }
  document.addEventListener('shopify:section:load', majour);
})();
